import { PartnerMobileMenu } from "@/apps/partner/components/PartnerMobileMenu/PartnerMobileMenu";
import { Header } from "@/components/Layout/Header/Header";
import { LogoutButton } from "@/components/Layout/LogoutButton/LogoutButton";

export const PartnerPortalHeader = () => (
  <Header>
    <div className="block xl:hidden">
      <PartnerMobileMenu />
    </div>
    <div className="z-0 hidden xl:block">
      <LogoutButton />
    </div>
  </Header>
);
